import { Info } from 'lucide-react';
import { useState } from 'react';

/**
 * Tooltip Component - Mostra spiegazione al passaggio del mouse
 */
const Tooltip = ({ text, children, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };

  return (
    <div 
      className="relative inline-flex items-center"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children || <Info className="w-4 h-4 text-gray-400 hover:text-gray-600 cursor-help" />}
      
      {isVisible && (
        <div className={`absolute ${positionClasses[position]} z-50 w-64 max-w-[280px]`}>
          <div className="bg-gray-900 text-white text-sm rounded-lg px-3 py-2 shadow-xl whitespace-normal">
            {text}
            {/* Arrow */}
            <div className={`absolute w-2 h-2 bg-gray-900 transform rotate-45 
              ${position === 'top' ? 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1' : ''}
              ${position === 'bottom' ? 'top-0 left-1/2 -translate-x-1/2 -translate-y-1' : ''}
              ${position === 'left' ? 'right-0 top-1/2 -translate-y-1/2 translate-x-1' : ''}
              ${position === 'right' ? 'left-0 top-1/2 -translate-y-1/2 -translate-x-1' : ''}
            `}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;

